import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1254debd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "product-select" }
const _hoisted_2 = {
  key: 0,
  id: "product-view",
  class: "container"
}
const _hoisted_3 = {
  key: 0,
  class: "side images"
}
const _hoisted_4 = { class: "main-image" }
const _hoisted_5 = ["src", "onClick"]
const _hoisted_6 = { class: "thumbnails" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "side content" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = {
  key: 0,
  class: "badge live"
}
const _hoisted_12 = {
  key: 1,
  class: "badge rng"
}
const _hoisted_13 = { class: "icons" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "features" }, " Key Features ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DesiredProducts = _resolveComponent("DesiredProducts")!
  const _component_FAIcon = _resolveComponent("FAIcon")!
  const _component_GalleryBox = _resolveComponent("GalleryBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DesiredProducts, { placement: 'products' }),
    (_ctx.selectedGame)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.gameData.images)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameImages, (image, index) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: index,
                      class: _normalizeClass({showing: _ctx.showingImage === index}),
                      src: require(`@/assets/img/${image.src}`),
                      onClick: ($event: any) => (_ctx.imageIndex = index)
                    }, null, 10, _hoisted_5))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameImages, (image, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: image,
                      class: _normalizeClass([{ active: _ctx.showingImage === index }, "thumb"]),
                      onClick: ($event: any) => (_ctx.showingImage = index)
                    }, [
                      _createElementVNode("img", {
                        src: require(`@/assets/img/${image.thumb}`)
                      }, null, 8, _hoisted_8)
                    ], 10, _hoisted_7))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.gameData.name), 1),
              (_ctx.gameData.live)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Live "))
                : _createCommentVNode("", true),
              (_ctx.gameData.rng)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, " RNG "))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_FAIcon, {
                  icon: "chevron-down",
                  class: "icon left",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.slide('left')))
                }),
                _createVNode(_component_FAIcon, {
                  icon: "chevron-down",
                  class: "icon right",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.slide('right')))
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameData.description, (desc, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: `description-${index}`,
                  class: "description"
                }, _toDisplayString(desc), 1))
              }), 128)),
              _hoisted_15,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameData.features, (feat, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `feature-${index}`
                  }, _toDisplayString(feat), 1))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_GalleryBox, {
      class: "images",
      startWithIndex: _ctx.imageIndex,
      images: _ctx.gameImages,
      onClear: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imageIndex = null))
    }, null, 8, ["startWithIndex", "images"])
  ]))
}